<template>
    <!-- BEGIN USER LOGIN DROPDOWN -->
    <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
    <li class="dropdown dropdown-user">
        <a href="javascript:;" class="dropdown-toggle" @click="$emit('toggle', {isOpen: !isOpen})">
            <img alt="" class="img-circle" :src="$store.state.account.avatar || ''"/>
            <span class="username username-hide-on-mobile">{{ $store.state.account.firstName || 'guest' }}</span>
            <i class="fa fa-angle-down"></i>
        </a>
        <transition name="fade">
            <ul v-show="isOpen" class="dropdown-menu dropdown-menu-default">
                <li v-if="$store.state.account.id">
                    <a v-if="$store.state.auth.authenticated" href="#"
                       @click.prevent="showChangePasswordDialog">
                        <i class="icon-key"></i> Change password
                    </a>
                    <!--<router-link-->
                    <!--:to="{name: `${$store.state.app.section}.user.profile`, params: {locale: this.$i18n.locale, section: $store.state.app.section}}">-->
                    <!--<i class="icon-user"></i>-->
                    <!--My Profile-->
                    <!--</router-link>-->
                </li>

                <!--<li>-->
                <!--<a href="app_todo.html">-->
                <!--<i class="icon-rocket"></i> My Tasks-->
                <!--<span class="badge badge-success"> 7</span>-->
                <!--</a>-->
                <!--</li>-->
                <li v-if="$store.state.account.id" class="divider"></li>
                <!--<li>-->
                <!--<a href="page_user_lock_1.html">-->
                <!--<i class="icon-lock"></i> Lock Screen-->
                <!--</a>-->
                <!--</li>-->
                <li>
                    <router-link
                            v-if="!$store.state.auth.authenticated"
                            :to="{name: 'login.index'}">
                        <i class="icon-login"></i>
                        Login
                    </router-link>
                    <a v-if="$store.state.auth.authenticated" href="#"
                       @click.prevent="logout();$emit('toggle', {isOpen: false})">
                        <i class="icon-logout"></i> Logout
                    </a>
                </li>
            </ul>
        </transition>
    </li>
    <!-- END USER LOGIN DROPDOWN -->
</template>

<script>
  export default {
    props: {
      isOpen: {
        default: false
      }
    },
    methods: {
      /**
       * Will log the user out.
       */
      logout () {
        this.$store.dispatch('auth/logout')
      },
      showChangePasswordDialog () {
        this.$confirm(
          'Do you really want to change your password? We can help by sending you a link to reset it.',
          'Password reset',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel'
          }
        )
          .then(() => {
            this.$api.resetpasswordPost({}, {
              email: this.$store.state.account.email
            }).then(
              this.$notify.info({
                title: 'Password reset',
                message: 'Email sent'
              })
                .catch((err) => {
                  console.log(err)
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error occured'
                  })
                })
            )
          })
          .catch(() => {})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/header/UserLogin.vue